var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlashActiveSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,2C7.2802734,2,1,8.2802734,1,16s6.2802734,14,14,14c1.6542969,0,3-1.3457031,3-3V5C18,3.3457031,16.6542969,2,15,2z  M16,27c0,0.5512695-0.4482422,1-1,1C8.3828125,28,3,22.6166992,3,16S8.3828125,4,15,4c0.5517578,0,1,0.4487305,1,1V27z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.7573586,
    y: 7.0001068,
    transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 1.372583 19.3137093)",
    width: 8.485281,
    height: 1.9997864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.0001068,
    y: 19.7573586,
    transform: "matrix(0.7071068 -0.7071068 0.7071068 0.7071068 -9.9411259 24)",
    width: 1.9997864,
    height: 8.485281
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 15,
    width: 8,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashActiveSmall);
export default __webpack_public_path__ + "static/media/flash-active--small.b2c9b26f47ec68d095d86f6eb90bfaa1.svg";
export { ForwardRef as ReactComponent };